import {
  AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild,
} from "@angular/core";

// AR-24  Lightweight canvas signature pad (no external package). Emits a PNG
// data-URL as the patient draws; empty string when cleared.
@Component({
  selector: "app-signature-pad",
  templateUrl: "./signature-pad.component.html",
  styleUrls: ["./signature-pad.component.scss"],
  standalone: false,
})
export class SignaturePadComponent implements AfterViewInit {
  @Output() changed = new EventEmitter<string>();
  @ViewChild("c") canvasRef!: ElementRef<HTMLCanvasElement>;

  private ctx!: CanvasRenderingContext2D;
  private drawing = false;
  private hasInk = false;

  ngAfterViewInit(): void {
    const cv = this.canvasRef.nativeElement;
    cv.width = cv.offsetWidth || 300;
    cv.height = 160;
    const ctx = cv.getContext("2d");
    if (!ctx) return;
    this.ctx = ctx;
    this.ctx.lineWidth = 2;
    this.ctx.lineCap = "round";
    this.ctx.strokeStyle = "#173D5B";
  }

  private pos(e: PointerEvent) {
    const r = this.canvasRef.nativeElement.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }

  start(e: PointerEvent): void {
    if (!this.ctx) return;
    e.preventDefault();
    this.drawing = true;
    const p = this.pos(e);
    this.ctx.beginPath();
    this.ctx.moveTo(p.x, p.y);
  }

  move(e: PointerEvent): void {
    if (!this.drawing || !this.ctx) return;
    e.preventDefault();
    const p = this.pos(e);
    this.ctx.lineTo(p.x, p.y);
    this.ctx.stroke();
    this.hasInk = true;
  }

  end(): void {
    if (!this.drawing) return;
    this.drawing = false;
    if (this.hasInk) this.changed.emit(this.canvasRef.nativeElement.toDataURL("image/png"));
  }

  clear(): void {
    if (!this.ctx) return;
    const cv = this.canvasRef.nativeElement;
    this.ctx.clearRect(0, 0, cv.width, cv.height);
    this.hasInk = false;
    this.changed.emit("");
  }
}
